import { Component, OnInit, ViewChild } from '@angular/core';
import { SwGridTableComponent } from 'src/app/librarys/components/basic-components/sw-table/sw-grid-table/sw-grid-table.component';
import { SwMassageBoxService } from 'src/app/librarys/serves/sw-massage-box.service';
import { KmsService } from 'src/app/areas/kms/kms.service';
import { SwMassageConfirmComponent } from 'src/app/librarys/components/basic-components/sw-massage-confirm/sw-massage-confirm.component';
import { Router } from '@angular/router';
import { SwJwtService } from 'src/app/librarys/serves/sw-jwt.service';
import { SwHttpClientService } from 'src/app/librarys/serves/sw-http-client.service';
import { PlatformLocation } from '@angular/common';
import { environment } from 'src/environments/environment';
import { SwCreateModalComponentService } from 'src/app/librarys/serves/sw-create-modal-component.service';
import { ViewSourceMaterialComponent } from './view-source-material/view-source-material.component';
declare var $;
@Component({
  selector: 'app-knowledge-extract-management',
  templateUrl: './knowledge-extract-management.component.html',
  styleUrls: ['./knowledge-extract-management.component.css']
})
export class KnowledgeExtractManagementComponent implements OnInit {
  @ViewChild("swtable") swtable: SwGridTableComponent;
  @ViewChild("trim") trim: SwMassageConfirmComponent;     //确认删除弹框
  statusOption:any = [
    {id:0,text:'全部'},
    {id:1,text:'未开始'},
    {id:2,text:'提取中'},
    {id:3,text:'已完成'},
    {id:4,text:'提取失败'}
  ];
  status = 0;
  // 可选用户
  userOption: any = [];
  // 创建人
  createUserId = '';
  // 创建时间
  createDate = '';
  // 表格数据
  datas: any = [];
  // 当前选中的数据
  selectedData: any = [];
  // 是否显示加载中
  isLoading: boolean = false;
  // 表格分页组件
  pageBase: any = {
    current: 1,
    size: 10
  }
  // 表格操作按钮
  toolbarArr = [
    ["batchDelete"],
    ["startTask", "stopTask", "viewResult"],
  ];
  toolbar = [[], []];
  //  表格选中行数据
  selectData: any = [];
  constructor(
    private box: SwMassageBoxService,
    private location: PlatformLocation,
    private jwt: SwJwtService,
    private http: SwHttpClientService,
    private kmsService: KmsService,
    private router: Router,
    private create: SwCreateModalComponentService
  ) { }

  ngOnInit() {
    // 查询工具按钮列表
    this.queryToolbarBtns(); 
    this.getAllUsers();
    this.handleSelectClick();
  }
  
  // 查询工具按钮列表
  queryToolbarBtns() {
    // 根据路径去查询配置的按钮
    let pathname = ["/", "", ""]
    try {
        pathname = this.location["location"].hash.split('?')[0].split("/");
    } catch (e) {

    }
    let systemId = this.jwt.getToken("systemId")
    // 准备拼接url
    let url = environment.seekerWebAPI + "function/queryButtonsByUri"
    // 要去掉#，故第一个参数不使用
    if (pathname.length > 1) {
        // 拼接uri
        url = url + "?uri=";
        for (let index = 1; index < pathname.length; index++) {
            url = url + "/" + pathname[index]
        }
    }
    // 拼接系统ID参数
    url = url + "&systemId=" + systemId;
    this.http.Post(url, {}).subscribe(data => {
        if (data.code == '200') {
            data.data.forEach((element) => {
                if (
                    this.toolbarArr[0].filter((item) => item == element.functionCode)
                        .length > 0
                ) {
                    this.toolbar[0].push({
                        status: true,
                        functionCode: element.functionCode,
                        functionName: element.functionName,
                        icon: element.icon,
                        children: [],
                    });
                }
                if (
                    this.toolbarArr[1].filter((item) => item == element.functionCode)
                        .length > 0
                ) {
                    this.toolbar[1].push({
                        status: true,
                        functionCode: element.functionCode,
                        functionName: element.functionName,
                        icon: element.icon,
                        children: [],
                    });
                }
            });
        } else {
            this.box.waring('当前用户按钮组权限获取失败！');
        }
    });
  }

  //enter键触发搜索
  enterSearch(event) {
    if (event.keyCode == '13') {
      this.handleSelectClick();
    }
  }

  // 查询按钮方法
  handleSelectClick() {
    this.pageBase = {
      current: 1,
      size: 10
    };
    this.getData();
  }

  //获取数据
  getData() {
    this.isLoading = true;
    let params = {};
    if (this.createDate) {
      params = {
        'current': this.pageBase.current,
        'size': this.pageBase.size,
        'createUserId': $.trim(this.createUserId),
        'startCreateDate': this.createDate.split('#')[0],
        'endCreateDate': this.createDate.split('#')[1],
        'status': this.status ? this.status : null
      }
    } else {
      params = {
        'current': this.pageBase.current,
        'size': this.pageBase.size,
        'createUserId': $.trim(this.createUserId),
        'status': this.status ? this.status : null
      }
    }
    this.kmsService.queryKeTaskList(params).subscribe(
      data => {
        this.isLoading = false;
        if (data.code == '200') {
          this.pageBase = data.data;
          this.datas = data.data.records;
        } else {
          this.box.waring(data.msg);
        }
      }
    );
  }

  // 表格分页点击方法
  handlePageClick(event) {
    this.pageBase = event;
    this.getData();
  }

  // 重置数据
  handleReloadClick() {
    this.createUserId = '';
    this.createDate = '';
    this.status = 0;
    this.handleSelectClick();
  }

  //  表格选择数据
  outSelectData(event) {
    //获取当前选中的所有数据
    this.selectData = event;
    //设置表格按钮组状态
    this.swtable.toolbarAllEnable();
    if (this.selectData.length == 0) {
      this.swtable.toolbarDisable("batchDelete");
    }
  }

  // 按钮点击事件
  onOperation(event) {
    switch (event) {
      // 批量删除
      case 'batchDelete':
        this.clickDelete();
        break;
    }
  }

  // 批量删除
  clickDelete() {
    if (this.selectData.length == 0) {
      this.box.danger('请至少选择一条数据！');
      return;
    }
    let len = this.selectData.filter(e => e.status !== 1).length;
    if (len > 0) {
      this.box.danger('已开始提取或提取完成的任务不允许删除！');
      return;
    }
    let ids = [];
    this.selectData.forEach(item => {
      ids.push(item.taskId);
    });
    this.delete(ids);
  }

  // 执行删除操作
  delete(ids){
    this.trim.openCLick("确认删除吗？", (data) => {
      if (data) {
        this.kmsService.deleteKeTaskByIds(ids).subscribe(
          data => {
            if (data["code"] == '200') {
              this.box.success("操作成功");
              this.getData();
            } else {
              this.box.waring(data.msg);
            }
          }
        )
      }
    })
  }

  clickTdBtn(type, data) {
    //禁止冒泡
    event.stopPropagation();
    if(type == 'start'){
      this.kmsService.startKeTask(data.taskId).subscribe(
        data => {
          if (data["code"] == '200') {
            this.box.success('开始执行该任务！');
            setTimeout(() => {
              this.getData();
            }, 500);
          } else {
            this.box.waring(data.msg);
          }
        }
      );
    }
    else if(type == 'stop'){
      this.trim.openCLick("该任务已经开始提取，强行终止会导致已抽取的数据丢失，请确认是否终止任务？", (res) => {
        if (res) {
          this.kmsService.endTask(data.taskId).subscribe(
            data => {
              if (data["code"] == '200') {
                this.box.success('已终止执行该任务！');
                setTimeout(() => {
                  this.getData();
                }, 500);
              } else {
                this.box.waring(data.msg);
              }
            }
          );
        }
      })
    }
    else if (type == 'view'){
      this.router.navigate(['/kms/EntityRelationMark'], {queryParams: {Title: '查看结果',upOrAdd:'textView',selectData:JSON.stringify({taskId:data.taskId})}});
    }
    else if(type == 'viewSource'){
      let param = {"selectedData": data };
      this.create.createModal(ViewSourceMaterialComponent, param);
    }
  }

  // 根据用户所属组织id查询所有用户信息、知识编辑人员、知识质检人员
  getAllUsers(){
    let systemId = this.jwt.getToken("systemId");
    // 获取知识库关联组织id(当前为用户所属组织id，需要进行修改)
    let orgId = this.jwt.getToken('orgId');
    let userParams = {
      entity: {
        systemId: systemId
      },
      organizeId: orgId,
      lazy:true,
      param: {
        systemId: systemId, 
        pageNum: 1,
        pageSize: 1000
      }
    }
    this.kmsService.queryUserByOrganizeId(userParams).subscribe(
      data => {
        if(data.code == '200'){
          let res = data.data && data.data.records ? data.data.records : [];
          if(res.length>0){
            res.forEach(el => {
                el['id'] = el['userId'];
                el['text'] = el['displayName'];
            })
            this.userOption = res;
          }
        }
      }
    )
  }

  toHour(second){
    // 秒转成小时
    return second ? ((second/60/60).toFixed(2))+'h' : '无';
  }

  getPercent(data){
    // 计算百分比
    return data.extractPages ? ((data.extractPages/data.totalPages)*100).toFixed(2)+'%' : '0%';
  }

  hasFunc(code){
    // 判断是否有该功能权限
    let res = this.toolbar[1].filter((item) => item.functionCode == code);
    return res.length>0? true : false;
  }
}



